import { SET_FONTS_IN_PROJECT_TO_STORE } from 'actions/index'
import _map from "lodash/map"
import { Action } from "app/types/app-types"

export type FontsInProject = string[]
const defaultFontsInProjectState: FontsInProject = []

export default function (state: FontsInProject = defaultFontsInProjectState, action: Action<FontsInProject>): FontsInProject {
    switch (action.type) {
        case SET_FONTS_IN_PROJECT_TO_STORE:
            return action.payload
        default:
            return state
    }
}
